import {
  Row,
  Col,
  Alert,
  Popconfirm,
  Button,
  Radio,
  message,
  Collapse,
  ConfigProvider,
  Badge,
  Spin,
  Tooltip,
  Checkbox,
} from "antd";

import { CloseCircleTwoTone } from "@ant-design/icons";
import axios from "axios";
import { LIST_FORMS } from "../../literals";
import { jsPDF } from "jspdf";
import { useEffect, useState, useRef } from "react";

import AnswerCall from "../ContactForm/AnswerCall";
import Registration from "../ContactForm/Registration";
import TANFWPCOOP from "../ContactForm/TANF_WPCOOP";
import CHILDCAREONLY from "../ContactForm/ChildCare";
import CC_TANF from "../ContactForm/CC_TANF";
import TANFDT from "../ContactForm/Tanf_DT";
import ScreenNameVR from "../ContactForm/ScreenName_VR";
import ScreenNamePW from "../ContactForm/ScreenName_PW";
import moment from "moment";
import CS_ALL_PROGRAMS from "../ContactForm/CS_AllPrograms";
import CS_AUTHREP from "../ContactForm/CS_AuthRep";
import CS_SUMMARY_SCREEN from "../ContactForm/CS_SummaryScreen";
import INDEMOSCREEN from "../ContactForm/IDS";
import CITIDENTITYLIST from "../ContactForm/CIL";
import HOUSEHOLDSTATUSLIST from "../ContactForm/HS_StatusList";
import RELATIONSHIPLIST from "../ContactForm/RelationshipList";
import PREGNANCYLIST from "../ContactForm/PregnancyList";
import OTHERPROGRAMLIST from "../ContactForm/OtherProgramList";
import NONCOMPLIANCELIST from "../ContactForm/NC_List";
import TIMELIMITSUMMARY from "../ContactForm/TimeLimitSummary";
import PURCHASEPREPARELIST from "../ContactForm/PP_List";
import SCHOOLATTLIST from "../ContactForm/SA_List";
import LIVINGARRANGEMENT from "../ContactForm/LivingArrangement";
import NONCUSTPARENTLIST from "../ContactForm/NC_ParentList";
import MEDCONDLIST from "../ContactForm/MC_List";
import EMPLISTINCLIST from "../ContactForm/EL_IncomeList";
import RESOURCELIST from "../ContactForm/ResourceList";
import EXPENSELIST from "../ContactForm/ExpenseList";
import DCEXPENSELIST from "../ContactForm/DC_ExpenseList";
import MDEXPENSELIST from "../ContactForm/MD_ExpenseList";
import MDCAREEXPENSELIST from "../ContactForm/MDC_ExpenseList";
import CHILDCARENEEDLIST from "../ContactForm/CC_NeedList";
import PCSCHEDULEDLIST from "../ContactForm/PC_ScheduleList";
import FAMPLANCHILDCARE from "../ContactForm/FP_ChildCareList";
import TANFSUSPENSIONBASED from "../ContactForm/SB_TANF";
import DVSASS from "../ContactForm/DVSA_StalkingScreening";
import ICEBT from "../ContactForm/IC_EBT";
import EXPEDITEDSTATUS from "../ContactForm/IC_ExpeditedStatus";
import ICMAWRS from "../ContactForm/IC_MAWRS";
import VERIFICATIONSLIST from "../ContactForm/VerificationsList";
import TODO from "../ContactForm/TODO";
import RUNEDBC from "../ContactForm/RunEDBC";
import NARRATIVE from "../ContactForm/Narrative";
// import AnswerCall from "../ContactForm/AnswerCall";
import RightsAndResponsibilities from "../ContactForm/RightsAndResp";
import ReportingPage from "../ContactForm/ReportingPage";

import useFormFetch from "../../hooks/useFormFetch";
import { LAMBDAS } from "../../literals";
// import { InfoCircleTwoTone } from "@ant-design/icons";
// import RETRIEVECONTACT from "./RetrieveContact";
// import useUpdateEffect from "../../hooks/useUpdateEffect";
// import useDataFetch from "../../hooks/useDataFetch";
// import useSaveData from "../../hooks/useSaveEffect";
// import { components } from "react-select";
import {
  update_answer_call_form,
  update_cctanf_form,
  update_childcareneedlist_form,
  update_childcareonly_form,
  update_citidentitylist_form,
  update_csallprograms_form,
  update_csauthrep_form,
  update_cssummaryscreen_form,
  update_dcexpenselist_form,
  update_dvsass_form,
  update_emplistinclist_form,
  update_expeditedstatus_form,
  update_expenselist_form,
  update_famplanchildcare_form,
  update_householdstatuslist_form,
  update_icebt_form,
  update_icmawrs_form,
  update_indemoscreen_form,
  update_livingarrangement_form,
  update_mdcareexpenselist_form,
  update_mdexpenselist_form,
  update_medcondlist_form,
  update_narrative_form,
  update_noncompliancelist_form,
  update_noncustparentlist_form,
  update_otherprogramlist_form,
  update_pcscheduledlist_form,
  update_pregnancylist_form,
  update_purchasepreparelist_form,
  update_registration_form,
  update_relationshiplist_form,
  update_reportingpage_form,
  update_resourcelist_form,
  update_right_resp_form,
  update_runedbc_form,
  update_schoolattlist_form,
  update_screenpw_form,
  update_screenvr_form,
  update_tanfdt_form,
  update_tanfsuspensionbased_form,
  update_tanfwpcoop_form,
  update_timelimitsummary_form,
  update_todo_form,
  update_verificationslist_form,
  setErrorCount_answer_call_form,
  setErrorCount_right_resp_form,
  setErrorCount_registration_form,
  setErrorCount_tanfdt_form,
  setErrorCount_cctanf_form,
  setErrorCount_tanfwpcoop_form,
  setErrorCount_childcareonly_form,
  setErrorCount_screenvr_form,
  setErrorCount_screenpw_form,
  setErrorCount_csallprograms_form,
  setErrorCount_csauthrep_form,
  setErrorCount_cssummaryscreen_form,
  setErrorCount_reportingpage_form,
  setErrorCount_indemoscreen_form,
  setErrorCount_citidentitylist_form,
  setErrorCount_householdstatuslist_form,
  setErrorCount_relationshiplist_form,
  setErrorCount_pregnancylist_form,
  setErrorCount_otherprogramlist_form,
  setErrorCount_noncompliancelist_form,
  setErrorCount_timelimitsummary_form,
  setErrorCount_purchasepreparelist_form,
  setErrorCount_schoolattlist_form,
  setErrorCount_livingarrangement_form,
  setErrorCount_noncustparentlist_form,
  setErrorCount_medcondlist_form,
  setErrorCount_emplistinclist_form,
  setErrorCount_resourcelist_form,
  setErrorCount_expenselist_form,
  setErrorCount_dcexpenselist_form,
  setErrorCount_mdexpenselist_form,
  setErrorCount_mdcareexpenselist_form,
  setErrorCount_childcareneedlist_form,
  setErrorCount_pcscheduledlist_form,
  setErrorCount_famplanchildcare_form,
  setErrorCount_tanfsuspensionbased_form,
  setErrorCount_dvsass_form,
  setErrorCount_icebt_form,
  setErrorCount_expeditedstatus_form,
  setErrorCount_icmawrs_form,
  setErrorCount_verificationslist_form,
  setErrorCount_todo_form,
  setErrorCount_runedbc_form,
  setErrorCount_narrative_form,
  update_alert_msg,
  set_agent_name,
  // update_interview_form_data,
} from "../../actions/form_slice";
import { useDispatch, useSelector } from "react-redux";
import dcf_logo from "../images/DCF_logo.png";

const { Panel } = Collapse;
// let datasource = [];
// let datasourceList = [];

const CustomerForm = (props) => {
  const temp_data_form_ref = useRef();
  const answer_call_form_ref = useRef();
  const right_resp_form_ref = useRef();
  const registration_form_ref = useRef();
  const tanfdt_form_ref = useRef();
  const tanfwpcoop_form_ref = useRef();
  const childcareonly_form_ref = useRef();
  const cctanf_form_ref = useRef();
  const screennamevr_form_ref = useRef();
  const screennamepw_form_ref = useRef();
  const csallprograms_form_ref = useRef();
  const csauthrep_form_ref = useRef();
  const cssummaryscreen_form_ref = useRef();
  const reportingpage_form_ref = useRef();
  const indemoscreen_form_ref = useRef();
  const citidentitylist_form_ref = useRef();
  const householdstatuslist_form_ref = useRef();
  const relationshiplist_form_ref = useRef();
  const pregnancylist_form_ref = useRef();
  const otherprogramlist_form_ref = useRef();
  const noncompliancelist_form_ref = useRef();
  const timelimitsummary_form_ref = useRef();
  const purchasepreparelist_form_ref = useRef();
  const schoolattlist_form_ref = useRef();
  const livingarrangement_form_ref = useRef();
  const noncustparentlist_form_ref = useRef();
  const medcondlist_form_ref = useRef();
  const emplistinclist_form_ref = useRef();
  const resourcelist_form_ref = useRef();
  const expenselist_form_ref = useRef();
  const dcexpenselist_form_ref = useRef();
  const mdexpenselist_form_ref = useRef();
  const mdcareexpenselist_form_ref = useRef();
  const childcareneedlist_form_ref = useRef();
  const pcscheduledlist_form_ref = useRef();
  const famplanchildcare_form_ref = useRef();
  const tanfsuspensionbased_form_ref = useRef();
  const dvsass_form_ref = useRef();
  const icebt_form_ref = useRef();
  const expeditedstatus_form_ref = useRef();
  const icmawrs_form_ref = useRef();
  const verificationslist_form_ref = useRef();
  const todo_form_ref = useRef();
  const runedbc_form_ref = useRef();
  const narrative_form_ref = useRef();
  const dispatch = useDispatch();
  const [interview_data, setInterviewData] = useState([]);
  const [load_data, set_load_data] = useState(false);
  const [is_contact_exist, set_contact_exists] = useState(false);
  const [is_contact_loading, set_contact_loading] = useState(false);
  const [agentName, setAgentName] = useState("");
  const [agentId, setAgentId] = useState("");
  const [documentName, setDocumentName] = useState("");
  const [callAnswered, setCallAnswered] = useState("");
  const [assessmentForm, setAssessmentForm] = useState(false);
  const [payLoad, setpayLoad] = useState(null);
  const [completed, setCompleted] = useState("");
  const [contactID, setContactID] = useState(props.contactID);
  const [sendEmail, setSendEmail] = useState(false);
  const [caseName, setCaseName] = useState(props.caseName);
  const [getLastAgentUpdate, setLastAgentUpdate] = useState({
    "Last Update Details": [],
  });
  const [collapse_active_keys, set_collapse_active_keys] = useState([
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
  ]);
  const intervalId = useRef(null);

  // const [retrievecontact_form] = Form.useForm();

  const answer_call_form_error_count = useSelector(
    (state) => state.form.answer_call_form_type
  );
  const right_resp_form_error_count = useSelector(
    (state) => state.form.right_resp_form_type
  );

  const registration_form_error_count = useSelector(
    (state) => state.form.registration_form_type
  );

  const tanfdt_form_error_count = useSelector(
    (state) => state.form.tanfdt_form_type
  );

  const tanfwpcoop_form_error_count = useSelector(
    (state) => state.form.tanfwpcoop_form_type
  );

  const childcareonly_form_error_count = useSelector(
    (state) => state.form.childcareonly_form_type
  );

  const cctanf_form_error_count = useSelector(
    (state) => state.form.cctanf_form_type
  );

  const screenvr_form_error_count = useSelector(
    (state) => state.form.screennamevr_form_type
  );

  const screenpw_form_error_count = useSelector(
    (state) => state.form.screennamepw_form_type
  );

  const csallprograms_form_error_count = useSelector(
    (state) => state.form.csallprograms_form_type
  );

  const csauthrep_form_error_count = useSelector(
    (state) => state.form.csauthrep_form_type
  );

  const cssummaryscreen_form_error_count = useSelector(
    (state) => state.form.cssummaryscreen_form_type
  );

  const reportingpage_form_error_count = useSelector(
    (state) => state.form.reportingpage_form_type
  );

  const indemoscreen_form_error_count = useSelector(
    (state) => state.form.indemoscreen_form_type
  );

  const citidentitylist_form_error_count = useSelector(
    (state) => state.form.citidentitylist_form_type
  );
  const householdstatuslist_form_error_count = useSelector(
    (state) => state.form.householdstatuslist_form_type
  );

  const relationshiplist_form_error_count = useSelector(
    (state) => state.form.relationshiplist_form_type
  );

  const pregnancylist_form_error_count = useSelector(
    (state) => state.form.pregnancylist_form_type
  );

  const otherprogramlist_form_error_count = useSelector(
    (state) => state.form.otherprogramlist_form_type
  );

  const noncompliancelist_form_error_count = useSelector(
    (state) => state.form.noncompliancelist_form_type
  );

  const timelimitsummary_form_error_count = useSelector(
    (state) => state.form.timelimitsummary_form_type
  );

  const purchasepreparelist_form_error_count = useSelector(
    (state) => state.form.purchasepreparelist_form_type
  );

  const schoolattlist_form_error_count = useSelector(
    (state) => state.form.schoolattlist_form_type
  );

  const livingarrangement_form_error_count = useSelector(
    (state) => state.form.livingarrangement_form_type
  );

  const noncustparentlist_form_error_count = useSelector(
    (state) => state.form.noncustparentlist_form_type
  );

  const medcondlist_form_error_count = useSelector(
    (state) => state.form.medcondlist_form_type
  );

  const emplistinclist_form_error_count = useSelector(
    (state) => state.form.emplistinclist_form_type
  );
  const resourcelist_form_error_count = useSelector(
    (state) => state.form.resourcelist_form_type
  );
  const expenselist_form_error_count = useSelector(
    (state) => state.form.expenselist_form_type
  );

  const dcexpenselist_form_error_count = useSelector(
    (state) => state.form.dcexpenselist_form_type
  );
  const mdexpenselist_form_error_count = useSelector(
    (state) => state.form.mdexpenselist_form_type
  );

  const mdcareexpenselist_form_error_count = useSelector(
    (state) => state.form.mdcareexpenselist_form_type
  );

  const childcareneedlist_form_error_count = useSelector(
    (state) => state.form.childcareneedlist_form_type
  );

  const pcscheduledlist_form_error_count = useSelector(
    (state) => state.form.pcscheduledlist_form_type
  );

  const famplanchildcare_form_error_count = useSelector(
    (state) => state.form.famplanchildcare_form_type
  );

  const tanfsuspensionbased_form_error_count = useSelector(
    (state) => state.form.tanfsuspensionbased_form_type
  );

  const dvsass_form_error_count = useSelector(
    (state) => state.form.dvsass_form_type
  );

  const icebt_form_error_count = useSelector(
    (state) => state.form.icebt_form_type
  );

  const expeditedstatus_form_error_count = useSelector(
    (state) => state.form.expeditedstatus_form_type
  );
  const icmawrs_form_error_count = useSelector(
    (state) => state.form.icmawrs_form_type
  );
  const verificationslist_form_error_count = useSelector(
    (state) => state.form.verificationslist_form_type
  );

  const todo_form_error_count = useSelector(
    (state) => state.form.todo_form_type
  );

  const runedbc_form_error_count = useSelector(
    (state) => state.form.runedbc_form_type
  );

  const narrative_form_error_count = useSelector(
    (state) => state.form.narrative_form_type
  );

  // const answer_call_form_details = useSelector(
  //   (state) => state.form.answer_call_form_type
  // );
  // const right_resp_form_details = useSelector(
  //   (state) => state.form.right_resp_form_type
  // );

  // const registration_form_details = useSelector(
  //   (state) => state.form.registration_form_type
  // );

  // const tanfdt_form_details = useSelector(
  //   (state) => state.form.tanfdt_form_type
  // );

  const autosave = () => {
    console.log("[autosave][1]", answer_call_form_ref);
    // if (answer_call_form_ref.current === null) {
    //   return;
    // }
    let auto_save_forms = [
      // {
      //   "Caller Details": {
      //     "Contact Id": contactID,
      //     "Call Answered": callAnswered,
      //   },
      // },

      {
        "TANF/CC/FOOD ASSISTANCE PROGRAM":
          answer_call_form_ref.current.getFieldsValue(),
      },
      {
        "RIGHTS AND RESPONSIBILITIES":
          right_resp_form_ref.current.getFieldsValue(),
      },
      {
        REGISTRATION: registration_form_ref.current.getFieldsValue(),
      },
      {
        "TANF Drug Testing Program Requirements":
          tanfdt_form_ref.current.getFieldsValue(),
      },
      {
        "TANF ONLY and WORK PROGRAM COOP":
          tanfwpcoop_form_ref.current.getFieldsValue(),
      },
      {
        "CHILD CARE ONLY": childcareonly_form_ref.current.getFieldsValue(),
      },
      {
        "CC/TANF ONLY": cctanf_form_ref.current.getFieldsValue(),
      },
      {
        "VOTER REGISTRATION": screennamevr_form_ref.current.getFieldsValue(),
      },
      {
        "PROGRAM WITHDRAW": screennamepw_form_ref.current.getFieldsValue(),
      },
      {
        "CASE SUMMARY (All Programs)":
          csallprograms_form_ref.current.getFieldsValue(),
      },
      {
        "AUTHORIZED REP": csauthrep_form_ref.current.getFieldsValue(),
      },
      {
        "CONTACT SUMMARY SCREEN (All Programs)":
          cssummaryscreen_form_ref.current.getFieldsValue(),
      },
      {
        "REPORTING PAGE (Reviews/IR ONLY)":
          reportingpage_form_ref.current.getFieldsValue(),
      },
      {
        "INDIVIDUAL DEMOGRAPHICS SCREEN (All Programs)":
          indemoscreen_form_ref.current.getFieldsValue(),
      },
      {
        "CITIZENSHIP/ IDENTITY LIST (All Programs)":
          citidentitylist_form_ref.current.getFieldsValue(),
      },
      {
        "HOUSEHOLD STATUS LIST":
          householdstatuslist_form_ref.current.getFieldsValue(),
      },
      {
        "RELATIONSHIP LIST (All Programs)":
          relationshiplist_form_ref.current.getFieldsValue(),
      },
      {
        "PREGNANCY LIST (All Programs)":
          pregnancylist_form_ref.current.getFieldsValue(),
      },
      {
        "OTHER PROGRAM LIST (All Programs)":
          otherprogramlist_form_ref.current.getFieldsValue(),
      },
      {
        "NON-COMPLIANCE LIST (All Programs)":
          noncompliancelist_form_ref.current.getFieldsValue(),
      },
      {
        "TIME LIMIT SUMMARY (All Programs)":
          timelimitsummary_form_ref.current.getFieldsValue(),
      },
      {
        "PURCHASE AND PREPARE LIST (FA)":
          purchasepreparelist_form_ref.current.getFieldsValue(),
      },
      {
        "SCHOOL ATTENDANCE LIST (All Programs)":
          schoolattlist_form_ref.current.getFieldsValue(),
      },
      {
        "LIVING ARRANGEMENTS":
          livingarrangement_form_ref.current.getFieldsValue(),
      },
      {
        "NONCUSTODIAL PARENT LIST (All Programs)":
          noncustparentlist_form_ref.current.getFieldsValue(),
      },
      {
        "MEDICAL CONDITION LIST (FA, TANF)":
          medcondlist_form_ref.current.getFieldsValue(),
      },
      {
        "EMPLOYMENT LIST /INCOME LIST":
          emplistinclist_form_ref.current.getFieldsValue(),
      },
      {
        "RESOURCE LIST (All Programs)":
          resourcelist_form_ref.current.getFieldsValue(),
      },
      {
        "SHELTER - EXPENSE LIST (FA, TANF)":
          expenselist_form_ref.current.getFieldsValue(),
      },
      {
        "DEPENDENT CARE/ CSS - EXPENSE LIST (FA, TANF)":
          dcexpenselist_form_ref.current.getFieldsValue(),
      },
      {
        "MEDICAL - EXPENSE LIST (FA, TANF)":
          mdexpenselist_form_ref.current.getFieldsValue(),
      },
      {
        "MEDICARE EXPENSE LIST (FA Only)":
          mdcareexpenselist_form_ref.current.getFieldsValue(),
      },
      {
        "CHILD CARE NEED LIST – PARENT AND/ OR CHILD CARE NEED LIST – CHILD (CC Only)":
          childcareneedlist_form_ref.current.getFieldsValue(),
      },
      {
        "PARENT SCHEDULE LIST AND/ OR CHILD SCHEDULE LIST (CC Only)":
          pcscheduledlist_form_ref.current.getFieldsValue(),
      },
      {
        "FAMILY PLAN – CHILD CARE LIST (CC Only)":
          famplanchildcare_form_ref.current.getFieldsValue(),
      },
      {
        "TANF Suspicion Based Drug Testing (Only those who meet suspicion-based indicators)":
          tanfsuspensionbased_form_ref.current.getFieldsValue(),
      },
      {
        "DOMESTIC VIOLENCE, SEXUAL ASSAULT, OR STALKING SCREENING (REQUIRED)":
          dvsass_form_ref.current.getFieldsValue(),
      },
      {
        EBT: icebt_form_ref.current.getFieldsValue(),
      },
      {
        "EXPEDITED STATUS": expeditedstatus_form_ref.current.getFieldsValue(),
      },
      {
        "MANDATORY ABAWD / E&T / WORK REGISTRANT SCRIPTS":
          icmawrs_form_ref.current.getFieldsValue(),
      },
      {
        "VERIFICATIONS LIST":
          verificationslist_form_ref.current.getFieldsValue(),
      },
      {
        TODO: todo_form_ref.current.getFieldsValue(),
      },
      {
        "RUN EDBC": runedbc_form_ref.current.getFieldsValue(),
      },
      {
        NARRATIVE: narrative_form_ref.current.getFieldsValue(),
      },
      getLastAgentUpdate,
    ];

    let contact_name =
      answer_call_form_ref.current.getFieldValue("Client Name");
    let contact_number =
      answer_call_form_ref.current.getFieldValue("Callback Number");
    const cDate = new Date();
    let dateNTimestampFormat =
      cDate.getFullYear() +
      "-" +
      String(cDate.getMonth() + 1).padStart(2, 0) +
      "-" +
      String(cDate.getDate()).padStart(2, 0) +
      "_" +
      Math.floor(cDate.getTime() / 1000);
    let file_name =
      "KEES Case^Journaling^" +
      `${props.caseNumber}` +
      "^" +
      contact_name +
      "^" +
      dateNTimestampFormat;

    // "_" +
    // props.agentName.replace(/ /g, "");
    // KEES Case^SSP Medical Uploaded Document^[CASE #]^[Case Name]^[DATE(Format: YEAR-Month-DAY)]^[Timestamp].pdf
    // props.agentName.toLowerCase().replace(/ /g, "");
    let isAutosave = true;
    console.log("[autosave][file_name][1]", load_data);
    sendContactDetails(
      file_name,
      contact_name,
      contact_number,
      auto_save_forms,
      isAutosave
    );
  };

  useEffect(() => {
    console.log("[autosave][1]", load_data);

    if (load_data) {
      intervalId.current = setInterval(autosave, 60000);
      console.log("[autosave][3]", load_data);
      autosave();
    } else {
      clearInterval(intervalId.current);
    }
    return () => clearInterval(intervalId.current);
  }, [load_data]);
  useEffect(() => {
    if (assessmentForm) {
      clearInterval(intervalId.current);
    }
  }, [assessmentForm]);

  const onValuesChange_answer_call_form = (formData) => {
    console.log("[onValuesChange_answer_call_form][formData]", formData);
    console.log(
      "[onValuesChange_answer_call_form][formData]",
      answer_call_form_ref
    );
    if (assessmentForm) {
      answer_call_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_answer_call_form(0));
          console.log("[ContactForm][AnswerCall]1", values);
        })
        .catch((error) => {
          console.log("[ContactForm][AnswerCall]2", error);
          dispatch(setErrorCount_answer_call_form(error.errorFields.length));
        });
    }

    // const errors = Object.values(formData).filter((val) => !val).length;
  };

  const onValuesChange_right_resp_form = (formData) => {
    if (assessmentForm) {
      right_resp_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_right_resp_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_right_resp_form(error.errorFields.length));
        });
    }

    // const errors = Object.values(formData).filter((val) => !val).length;
    // dispatch(setErrorCount_right_resp_form(errors));
  };

  const onValuesChange_registration_form = (formData) => {
    if (assessmentForm) {
      registration_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_registration_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_registration_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_tanfdt_form = (formData) => {
    if (assessmentForm) {
      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_tanfwpcoop_form = (formData) => {
    if (assessmentForm) {
      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_childcareonly_form = (formData) => {
    if (assessmentForm) {
      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_cctanf_form = (formData) => {
    if (assessmentForm) {
      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_screennamevr_form = (formData) => {
    if (assessmentForm) {
      screennamevr_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_screenvr_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_screenvr_form(error.errorFields.length));
        });
      screennamepw_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_screenpw_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_screenpw_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_screennamepw_form = (formData) => {
    if (assessmentForm) {
      screennamevr_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_screenvr_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_screenvr_form(error.errorFields.length));
        });
      screennamepw_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_screenpw_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_screenpw_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_csallprograms_form = (formData) => {
    if (assessmentForm) {
      csallprograms_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_csallprograms_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_csallprograms_form(error.errorFields.length));
        });

      csauthrep_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_csauthrep_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_csauthrep_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_csauthrep_form = (formData) => {
    if (assessmentForm) {
      csauthrep_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_csauthrep_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_csauthrep_form(error.errorFields.length));
        });
      csallprograms_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_csallprograms_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_csallprograms_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_cssummaryscreen_form = (formData) => {
    if (assessmentForm) {
      cssummaryscreen_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_cssummaryscreen_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_cssummaryscreen_form(error.errorFields.length)
          );
        });
      reportingpage_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_reportingpage_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_reportingpage_form(error.errorFields.length));
        });
      indemoscreen_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_indemoscreen_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_indemoscreen_form(error.errorFields.length));
        });
      citidentitylist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_citidentitylist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_citidentitylist_form(error.errorFields.length)
          );
        });
      householdstatuslist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_householdstatuslist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_householdstatuslist_form(error.errorFields.length)
          );
        });
      relationshiplist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_relationshiplist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_relationshiplist_form(error.errorFields.length)
          );
        });
      pregnancylist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_pregnancylist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_pregnancylist_form(error.errorFields.length));
        });
      otherprogramlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_otherprogramlist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_otherprogramlist_form(error.errorFields.length)
          );
        });
      noncompliancelist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_noncompliancelist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_noncompliancelist_form(error.errorFields.length)
          );
        });
      timelimitsummary_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_timelimitsummary_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_timelimitsummary_form(error.errorFields.length)
          );
        });
      purchasepreparelist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_purchasepreparelist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_purchasepreparelist_form(error.errorFields.length)
          );
        });
      schoolattlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_schoolattlist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_schoolattlist_form(error.errorFields.length));
        });
      livingarrangement_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_livingarrangement_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_livingarrangement_form(error.errorFields.length)
          );
        });
      noncustparentlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_noncustparentlist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_noncustparentlist_form(error.errorFields.length)
          );
        });
      medcondlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_medcondlist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_medcondlist_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_emplistinclist_form = (formData) => {
    if (assessmentForm) {
      emplistinclist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_emplistinclist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_emplistinclist_form(error.errorFields.length));
        });
      resourcelist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_resourcelist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_resourcelist_form(error.errorFields.length));
        });
    }
  };

  const onValuesChange_expenselist_form = (formData) => {
    if (assessmentForm) {
      expenselist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_expenselist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_expenselist_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_dcexpenselist_form = (formData) => {
    if (assessmentForm) {
      dcexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_dcexpenselist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_dcexpenselist_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_mdexpenselist_form = (formData) => {
    if (assessmentForm) {
      mdexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_mdexpenselist_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_mdexpenselist_form(error.errorFields.length));
        });
      mdcareexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_mdcareexpenselist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_mdcareexpenselist_form(error.errorFields.length)
          );
        });
    }
  };
  const onValuesChange_childcareneedlist_form = (formData) => {
    if (assessmentForm) {
      childcareneedlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_childcareneedlist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_childcareneedlist_form(error.errorFields.length)
          );
        });
      pcscheduledlist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_pcscheduledlist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_pcscheduledlist_form(error.errorFields.length)
          );
        });
      famplanchildcare_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_famplanchildcare_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_famplanchildcare_form(error.errorFields.length)
          );
        });
      tanfsuspensionbased_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_tanfsuspensionbased_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_tanfsuspensionbased_form(error.errorFields.length)
          );
        });
      dvsass_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_dvsass_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_dvsass_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_icebt_form = (formData) => {
    if (assessmentForm) {
      icebt_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_icebt_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_icebt_form(error.errorFields.length));
        });
      expeditedstatus_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_expeditedstatus_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_expeditedstatus_form(error.errorFields.length)
          );
        });
      icmawrs_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_icmawrs_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_icmawrs_form(error.errorFields.length));
        });
      verificationslist_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_verificationslist_form(0));
        })
        .catch((error) => {
          dispatch(
            setErrorCount_verificationslist_form(error.errorFields.length)
          );
        });
      todo_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_todo_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_todo_form(error.errorFields.length));
        });
      runedbc_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_runedbc_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_runedbc_form(error.errorFields.length));
        });
    }
  };
  const onValuesChange_narrative_form = (formData) => {
    if (assessmentForm) {
      narrative_form_ref.current
        .validateFields()
        .then((values) => {
          dispatch(setErrorCount_narrative_form(0));
        })
        .catch((error) => {
          dispatch(setErrorCount_narrative_form(error.errorFields.length));
        });
    }
  };

  const getAllFormData = () => {
    console.log("[getAllFormData]");
    // submit_form_ref();
    setAssessmentForm(true);
    try {
      let interviewFormData = [
        {
          "Caller Details": {
            "Contact Id": contactID,
            "Call Answered": callAnswered,
          },
        },
      ];

      answer_call_form_ref.current
        .validateFields()
        .then((values) => {
          // setInterviewData();
          interviewFormData.push({ "TANF/CC/FOOD ASSISTANCE PROGRAM": values });
          dispatch(setErrorCount_answer_call_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TANF/CC/FOOD ASSISTANCE PROGRAM": error.values,
          });
          dispatch(setErrorCount_answer_call_form(error.errorFields.length));
          console.log("[getAllFormData][answer]", error);
        });

      right_resp_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "RIGHTS AND RESPONSIBILITIES": values });
          dispatch(setErrorCount_right_resp_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "RIGHTS AND RESPONSIBILITIES": error.values,
          });
          dispatch(setErrorCount_right_resp_form(error.errorFields.length));
        });

      registration_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ REGISTRATION: values });
          dispatch(setErrorCount_registration_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ REGISTRATION: error.values });
          dispatch(setErrorCount_registration_form(error.errorFields.length));
        });

      tanfdt_form_ref.current
        .validateFields()
        .then((values) => {
          // values["Date of Conviction"] =
          //   values["Date of Conviction"].toISOString();
          values["Date of Conviction"] = moment(values["Date of Conviction"]);
          interviewFormData.push({
            "TANF Drug Testing Program Requirements": values,
          });
          dispatch(setErrorCount_tanfdt_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TANF Drug Testing Program Requirements": error.values,
          });
          dispatch(setErrorCount_tanfdt_form(error.errorFields.length));
        });
      tanfwpcoop_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "TANF ONLY and WORK PROGRAM COOP": values });
          dispatch(setErrorCount_tanfwpcoop_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TANF ONLY and WORK PROGRAM COOP": error.values,
          });
          dispatch(setErrorCount_tanfwpcoop_form(error.errorFields.length));
        });
      childcareonly_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "CHILD CARE ONLY": values });
          dispatch(setErrorCount_childcareonly_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "CHILD CARE ONLY": error.values });
          dispatch(setErrorCount_childcareonly_form(error.errorFields.length));
        });
      cctanf_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "CC/TANF ONLY": values });
          dispatch(setErrorCount_cctanf_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "CC/TANF ONLY": error.values });
          dispatch(setErrorCount_cctanf_form(error.errorFields.length));
        });
      screennamevr_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "VOTER REGISTRATION": values });
          dispatch(setErrorCount_screenvr_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "VOTER REGISTRATION": error.values });
          dispatch(setErrorCount_screenvr_form(error.errorFields.length));
        });
      screennamepw_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "PROGRAM WITHDRAW": values });
          dispatch(setErrorCount_screenpw_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "PROGRAM WITHDRAW": error.values });
          dispatch(setErrorCount_screenpw_form(error.errorFields.length));
        });
      csallprograms_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "CASE SUMMARY (All Programs)": values });
          dispatch(setErrorCount_csallprograms_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "CASE SUMMARY (All Programs)": error.values,
          });
          dispatch(setErrorCount_csallprograms_form(error.errorFields.length));
        });

      csauthrep_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({ "AUTHORIZED REP": values });
          dispatch(setErrorCount_csauthrep_form(0));
        })
        .catch((error) => {
          interviewFormData.push({ "AUTHORIZED REP": error.values });
          dispatch(setErrorCount_csauthrep_form(error.errorFields.length));
        });

      cssummaryscreen_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "CONTACT SUMMARY SCREEN (All Programs)": values,
          });
          dispatch(setErrorCount_cssummaryscreen_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "CONTACT SUMMARY SCREEN (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_cssummaryscreen_form(error.errorFields.length)
          );
        });
      reportingpage_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "REPORTING PAGE (Reviews/IR ONLY)": values,
          });
          dispatch(setErrorCount_reportingpage_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "REPORTING PAGE (Reviews/IR ONLY)": error.values,
          });
          dispatch(setErrorCount_reportingpage_form(error.errorFields.length));
        });

      indemoscreen_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "INDIVIDUAL DEMOGRAPHICS SCREEN (All Programs)": values,
          });
          dispatch(setErrorCount_indemoscreen_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "INDIVIDUAL DEMOGRAPHICS SCREEN (All Programs)": error.values,
          });
          dispatch(setErrorCount_indemoscreen_form(error.errorFields.length));
        });

      citidentitylist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "CITIZENSHIP/ IDENTITY LIST (All Programs)": values,
          });
          dispatch(setErrorCount_citidentitylist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "CITIZENSHIP/ IDENTITY LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_citidentitylist_form(error.errorFields.length)
          );
        });
      householdstatuslist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "HOUSEHOLD STATUS LIST": values,
          });
          dispatch(setErrorCount_householdstatuslist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "HOUSEHOLD STATUS LIST": error.values,
          });
          dispatch(
            setErrorCount_householdstatuslist_form(error.errorFields.length)
          );
        });
      relationshiplist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "RELATIONSHIP LIST (All Programs)": values,
          });
          dispatch(setErrorCount_relationshiplist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "RELATIONSHIP LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_relationshiplist_form(error.errorFields.length)
          );
        });
      pregnancylist_form_ref.current
        .validateFields()
        .then((values) => {
          values["Due Date"] = moment(values["Due Date"]);
          interviewFormData.push({
            "PREGNANCY LIST (All Programs)": values,
          });
          dispatch(setErrorCount_pregnancylist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "PREGNANCY LIST (All Programs)": error.values,
          });
          dispatch(setErrorCount_pregnancylist_form(error.errorFields.length));
        });
      otherprogramlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "OTHER PROGRAM LIST (All Programs)": values,
          });
          dispatch(setErrorCount_otherprogramlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "OTHER PROGRAM LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_otherprogramlist_form(error.errorFields.length)
          );
        });
      noncompliancelist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "NON-COMPLIANCE LIST (All Programs)": values,
          });
          dispatch(setErrorCount_noncompliancelist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "NON-COMPLIANCE LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_noncompliancelist_form(error.errorFields.length)
          );
        });
      timelimitsummary_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "TIME LIMIT SUMMARY (All Programs)": values,
          });
          dispatch(setErrorCount_timelimitsummary_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TIME LIMIT SUMMARY (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_timelimitsummary_form(error.errorFields.length)
          );
        });

      purchasepreparelist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "PURCHASE AND PREPARE LIST (FA)": values,
          });
          dispatch(setErrorCount_purchasepreparelist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "PURCHASE AND PREPARE LIST (FA)": error.values,
          });
          dispatch(
            setErrorCount_purchasepreparelist_form(error.errorFields.length)
          );
        });
      schoolattlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "SCHOOL ATTENDANCE LIST (All Programs)": values,
          });
          dispatch(setErrorCount_schoolattlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "SCHOOL ATTENDANCE LIST (All Programs)": error.values,
          });
          dispatch(setErrorCount_schoolattlist_form(error.errorFields.length));
        });
      livingarrangement_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "LIVING ARRANGEMENTS": values,
          });
          dispatch(setErrorCount_livingarrangement_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "LIVING ARRANGEMENTS": error.values,
          });
          dispatch(
            setErrorCount_livingarrangement_form(error.errorFields.length)
          );
        });
      noncustparentlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "NONCUSTODIAL PARENT LIST (All Programs)": values,
          });
          dispatch(setErrorCount_noncustparentlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "NONCUSTODIAL PARENT LIST (All Programs)": error.values,
          });
          dispatch(
            setErrorCount_noncustparentlist_form(error.errorFields.length)
          );
        });
      medcondlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "MEDICAL CONDITION LIST (FA, TANF)": values,
          });
          dispatch(setErrorCount_medcondlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "MEDICAL CONDITION LIST (FA, TANF)": error.values,
          });
          dispatch(setErrorCount_medcondlist_form(error.errorFields.length));
        });

      emplistinclist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "EMPLOYMENT LIST /INCOME LIST": values,
          });
          dispatch(setErrorCount_emplistinclist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "EMPLOYMENT LIST /INCOME LIST": error.values,
          });
          dispatch(setErrorCount_emplistinclist_form(error.errorFields.length));
        });
      resourcelist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "RESOURCE LIST (All Programs)": values,
          });
          dispatch(setErrorCount_resourcelist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "RESOURCE LIST (All Programs)": error.values,
          });
          dispatch(setErrorCount_resourcelist_form(error.errorFields.length));
        });
      expenselist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "SHELTER - EXPENSE LIST (FA, TANF)": values,
          });
          dispatch(setErrorCount_expenselist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "SHELTER - EXPENSE LIST (FA, TANF)": error.values,
          });
          dispatch(setErrorCount_expenselist_form(error.errorFields.length));
        });
      dcexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "DEPENDENT CARE/ CSS - EXPENSE LIST (FA, TANF)": values,
          });
          dispatch(setErrorCount_dcexpenselist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "DEPENDENT CARE/ CSS - EXPENSE LIST (FA, TANF)": error.values,
          });
          dispatch(setErrorCount_dcexpenselist_form(error.errorFields.length));
        });
      mdexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "MEDICAL - EXPENSE LIST (FA, TANF)": values,
          });
          dispatch(setErrorCount_mdexpenselist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "MEDICAL - EXPENSE LIST (FA, TANF)": error.values,
          });
          dispatch(setErrorCount_mdexpenselist_form(error.errorFields.length));
        });
      mdcareexpenselist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "MEDICARE EXPENSE LIST (FA Only)": values,
          });
          dispatch(setErrorCount_mdcareexpenselist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "MEDICARE EXPENSE LIST (FA Only)": error.values,
          });
          dispatch(
            setErrorCount_mdcareexpenselist_form(error.errorFields.length)
          );
        });
      childcareneedlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "CHILD CARE NEED LIST – PARENT AND/ OR CHILD CARE NEED LIST – CHILD (CC Only)":
              values,
          });
          dispatch(setErrorCount_childcareneedlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "CHILD CARE NEED LIST – PARENT AND/ OR CHILD CARE NEED LIST – CHILD (CC Only)":
              error.values,
          });
          dispatch(
            setErrorCount_childcareneedlist_form(error.errorFields.length)
          );
        });
      pcscheduledlist_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "PARENT SCHEDULE LIST AND/ OR CHILD SCHEDULE LIST (CC Only)":
              values,
          });
          dispatch(setErrorCount_pcscheduledlist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "PARENT SCHEDULE LIST AND/ OR CHILD SCHEDULE LIST (CC Only)":
              error.values,
          });
          dispatch(
            setErrorCount_pcscheduledlist_form(error.errorFields.length)
          );
        });
      famplanchildcare_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "FAMILY PLAN – CHILD CARE LIST (CC Only)": values,
          });
          dispatch(setErrorCount_famplanchildcare_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "FAMILY PLAN – CHILD CARE LIST (CC Only)": error.values,
          });
          dispatch(
            setErrorCount_famplanchildcare_form(error.errorFields.length)
          );
        });
      tanfsuspensionbased_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "TANF Suspicion Based Drug Testing (Only those who meet suspicion-based indicators)":
              values,
          });
          dispatch(setErrorCount_tanfsuspensionbased_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "TANF Suspicion Based Drug Testing (Only those who meet suspicion-based indicators)":
              error.values,
          });
          dispatch(
            setErrorCount_tanfsuspensionbased_form(error.errorFields.length)
          );
        });
      dvsass_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "DOMESTIC VIOLENCE, SEXUAL ASSAULT, OR STALKING SCREENING (REQUIRED)":
              values,
          });
          dispatch(setErrorCount_dvsass_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "DOMESTIC VIOLENCE, SEXUAL ASSAULT, OR STALKING SCREENING (REQUIRED)":
              error.values,
          });
          dispatch(setErrorCount_dvsass_form(error.errorFields.length));
        });
      icebt_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            EBT: values,
          });
          dispatch(setErrorCount_icebt_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            EBT: error.values,
          });
          dispatch(setErrorCount_icebt_form(error.errorFields.length));
        });
      expeditedstatus_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "EXPEDITED STATUS": values,
          });
          dispatch(setErrorCount_expeditedstatus_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "EXPEDITED STATUS": error.values,
          });
          dispatch(
            setErrorCount_expeditedstatus_form(error.errorFields.length)
          );
        });
      icmawrs_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "MANDATORY ABAWD / E&T / WORK REGISTRANT SCRIPTS": values,
          });
          dispatch(setErrorCount_icmawrs_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "MANDATORY ABAWD / E&T / WORK REGISTRANT SCRIPTS": error.values,
          });
          dispatch(setErrorCount_icmawrs_form(error.errorFields.length));
        });
      verificationslist_form_ref.current
        .validateFields()
        .then((values) => {
          values["Due Date"] = moment(values["Due Date"]);
          interviewFormData.push({
            "VERIFICATIONS LIST": values,
          });
          dispatch(setErrorCount_verificationslist_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "VERIFICATIONS LIST": error.values,
          });
          dispatch(
            setErrorCount_verificationslist_form(error.errorFields.length)
          );
        });
      todo_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            TODO: values,
          });
          dispatch(setErrorCount_todo_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            TODO: error.values,
          });
          dispatch(setErrorCount_todo_form(error.errorFields.length));
        });
      runedbc_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            "RUN EDBC": values,
          });
          dispatch(setErrorCount_runedbc_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            "RUN EDBC": error.values,
          });
          dispatch(setErrorCount_runedbc_form(error.errorFields.length));
        });
      narrative_form_ref.current
        .validateFields()
        .then((values) => {
          interviewFormData.push({
            NARRATIVE: values,
          });
          dispatch(setErrorCount_narrative_form(0));
        })
        .catch((error) => {
          interviewFormData.push({
            NARRATIVE: error.values,
          });
          dispatch(setErrorCount_narrative_form(error.errorFields.length));
        });
      const c_date = new Date();
      let dateAndTimeSubmitted = moment(
        c_date,
        "MMMM Do YYYY, h:mm:ss a"
      ).format("LLL");

      let currentAgent = {
        contactId: contactID,
        "Last Update by": agentName,
        "Date and Time": dateAndTimeSubmitted,
      };
      console.log("Last Update", getLastAgentUpdate);
      console.log("Last Update1", currentAgent);
      // console.log("Last Update", currentAgent);
      let lastUpdatedBy = [
        ...getLastAgentUpdate["Last Update Details"],
        currentAgent,
      ];

      console.log("Last Update5", lastUpdatedBy);
      // setLastAgentUpdate({ "Last Update Details": lastUpdatedBy });
      interviewFormData.push({
        "Last Update Details": lastUpdatedBy,
      });

      setInterviewData(interviewFormData);
    } catch (error) {
      console.log("Error during validation", error);
    }
  };

  const getContact = async (case_number) => {
    try {
      // const { data: response } = await axios.get(
      //   LAMBDAS.GET_FORM_DETAILS +
      //     contactName +
      //     "&phoneNumber=" +
      //     contactPhoneNumber
      // );
      console.log("[getContact][caseNumber]", case_number); //replaced contact_id to case_number
      // const { data: response } = await axios.get(
      //   LAMBDAS.GET_FORM_DETAILS + retrieve_contact_id
      // );
      const { data: response } = await axios.get(
        LAMBDAS.GET_FORM_DETAILS + case_number
      );
      if (response.response !== "DATA DOES NOT EXIST") {
        let get_data = response.response;
        console.log("[getContact][datasourceList]", get_data);
        let form_data = get_data.form_details;
        if (get_data.form_details.length > 45) {
          form_data.shift();
          // console.log("[getContact][datasourceList][1]", form_data);
        } else if (get_data.form_details.length === 45) {
          setLastAgentUpdate(form_data[44]);
        }
        setCallAnswered(get_data.callAnswered);

        // console.log("[getContact][datasourceList][2]", form_data);
        // setContactID(case_number);
        populate_form(form_data);

        // onClose();
      } else {
        // setMsg(true);

        set_load_data(false);
        dispatch(update_alert_msg(true));
        clearFields();
        set_contact_exists(false);
      }
    } catch (error) {
      console.log(error);
      // setMsg(true);
    }
  };
  const sendContactDetails = (
    file_name,
    contact_name,
    contact_number,
    items,
    is_autosave
  ) => {
    const c_date = new Date();
    let time_date_submitted = moment(c_date, "MMMM Do YYYY, h:mm:ss a").format(
      "LLL"
    );
    if (contact_name === undefined || contact_name === null) {
      contact_name = "";
    }
    if (contact_number === undefined || contact_number === null) {
      contact_number = "";
    }

    let contactDetails = {
      fileName: file_name,
      contactId: contactID, //"casenumberherexx09252025",
      caseNumber: props.caseNumber,
      contactName: contact_name,
      contactPhoneNumber: contact_number,
      callAnswered: callAnswered,
      dateTimeSubmitted: time_date_submitted,
      agentName: agentName,
      formDetails: items,
      isAutosave: is_autosave,
      agentId: props.agentID,
    };
    console.log("[sendContactDetails]", contactDetails);

    fetch(LAMBDAS.SAVE_CONTACT, {
      method: "POST",
      body: JSON.stringify(contactDetails),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("[sendContactDetails][Success]:", result.response);
        if (result.response === "SUCCESS") {
          console.log(
            "[sendContactDetails][Success][InsideIf]:",
            result.response
          );
          if (completed === "INCOMPLETE") {
            message.success("Form Submitted Successfully!");
            setAssessmentForm(false);
            set_load_data(false);
            clearFields();
            set_contact_exists(false);
          }
        } else {
          message.error("Failed to save. Please try again.");
          console.log("[sendContactDetails][error]");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        console.log("[sendContactDetails][error]", error);
      });
  };

  const sendEmailByAgent = (contact_id, details, contact_filename) => {
    const c_date = new Date();
    let time_date_submitted = moment(c_date, "MMMM Do YYYY, h:mm:ss a").format(
      "LLL"
    );

    let contactDetails = {
      contactId: contact_id,
      contactFileName: contact_filename,
      agentId: agentId,
      emailAttachment: details,
      dateTimeSubmitted: time_date_submitted,
    };
    console.log("[sendEmailByAgent]", contactDetails);

    fetch(LAMBDAS.SEND_EMAIL, {
      method: "POST",
      body: JSON.stringify(contactDetails),
    })
      .then((response) => response.json())
      .then((result) => {
        console.log("[sendEmailByAgent][Success]:", result.response);
        if (result.response === "SUCCESS") {
          console.log(
            "[sendEmailByAgent][Success][InsideIf]:",
            result.response
          );
        } else {
          console.log("[sendEmailByAgent][error]");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        console.log("[sendEmailByAgent][error]", error);
      });
  };

  const clearFields = () => {
    setContactID(""); //caseNumber
    // setAgentID("");
    setCallAnswered("");
    // setContactName("");
    setCompleted("");
    // answer_call_form_ref.current.setFields([]);
    answer_call_form_ref.current.resetFields();
    right_resp_form_ref.current.resetFields();
    registration_form_ref.current.resetFields();
    tanfdt_form_ref.current.resetFields();
    tanfwpcoop_form_ref.current.resetFields();
    childcareonly_form_ref.current.resetFields();
    cctanf_form_ref.current.resetFields();
    screennamevr_form_ref.current.resetFields();
    screennamepw_form_ref.current.resetFields();
    csallprograms_form_ref.current.resetFields();
    csauthrep_form_ref.current.resetFields();
    cssummaryscreen_form_ref.current.resetFields();
    reportingpage_form_ref.current.resetFields();
    indemoscreen_form_ref.current.resetFields();
    citidentitylist_form_ref.current.resetFields();
    householdstatuslist_form_ref.current.resetFields();
    relationshiplist_form_ref.current.resetFields();
    pregnancylist_form_ref.current.resetFields();
    otherprogramlist_form_ref.current.resetFields();
    noncompliancelist_form_ref.current.resetFields();
    timelimitsummary_form_ref.current.resetFields();
    purchasepreparelist_form_ref.current.resetFields();
    schoolattlist_form_ref.current.resetFields();
    livingarrangement_form_ref.current.resetFields();
    noncustparentlist_form_ref.current.resetFields();
    medcondlist_form_ref.current.resetFields();
    emplistinclist_form_ref.current.resetFields();
    resourcelist_form_ref.current.resetFields();
    expenselist_form_ref.current.resetFields();
    dcexpenselist_form_ref.current.resetFields();
    mdexpenselist_form_ref.current.resetFields();
    mdcareexpenselist_form_ref.current.resetFields();
    childcareneedlist_form_ref.current.resetFields();
    pcscheduledlist_form_ref.current.resetFields();
    famplanchildcare_form_ref.current.resetFields();
    tanfsuspensionbased_form_ref.current.resetFields();
    dvsass_form_ref.current.resetFields();
    icebt_form_ref.current.resetFields();
    expeditedstatus_form_ref.current.resetFields();
    icmawrs_form_ref.current.resetFields();
    verificationslist_form_ref.current.resetFields();
    todo_form_ref.current.resetFields();
    runedbc_form_ref.current.resetFields();
    narrative_form_ref.current.resetFields();
    dispatch(set_agent_name(""));
    dispatch(setErrorCount_answer_call_form(0));
    dispatch(setErrorCount_right_resp_form(0));
    dispatch(setErrorCount_registration_form(0));
    dispatch(setErrorCount_tanfdt_form(0));
    dispatch(setErrorCount_cctanf_form(0));
    dispatch(setErrorCount_tanfwpcoop_form(0));
    dispatch(setErrorCount_childcareonly_form(0));
    dispatch(setErrorCount_screenvr_form(0));
    dispatch(setErrorCount_screenpw_form(0));
    dispatch(setErrorCount_csallprograms_form(0));
    dispatch(setErrorCount_csauthrep_form(0));
    dispatch(setErrorCount_cssummaryscreen_form(0));
    dispatch(setErrorCount_reportingpage_form(0));
    dispatch(setErrorCount_indemoscreen_form(0));
    dispatch(setErrorCount_citidentitylist_form(0));
    dispatch(setErrorCount_householdstatuslist_form(0));
    dispatch(setErrorCount_relationshiplist_form(0));
    dispatch(setErrorCount_pregnancylist_form(0));
    dispatch(setErrorCount_otherprogramlist_form(0));
    dispatch(setErrorCount_noncompliancelist_form(0));
    dispatch(setErrorCount_timelimitsummary_form(0));
    dispatch(setErrorCount_purchasepreparelist_form(0));
    dispatch(setErrorCount_schoolattlist_form(0));
    dispatch(setErrorCount_livingarrangement_form(0));
    dispatch(setErrorCount_noncustparentlist_form(0));
    dispatch(setErrorCount_medcondlist_form(0));
    dispatch(setErrorCount_emplistinclist_form(0));
    dispatch(setErrorCount_resourcelist_form(0));
    dispatch(setErrorCount_expenselist_form(0));
    dispatch(setErrorCount_dcexpenselist_form(0));
    dispatch(setErrorCount_mdexpenselist_form(0));
    dispatch(setErrorCount_mdcareexpenselist_form(0));
    dispatch(setErrorCount_childcareneedlist_form(0));
    dispatch(setErrorCount_pcscheduledlist_form(0));
    dispatch(setErrorCount_famplanchildcare_form(0));
    dispatch(setErrorCount_tanfsuspensionbased_form(0));
    dispatch(setErrorCount_dvsass_form(0));
    dispatch(setErrorCount_icebt_form(0));
    dispatch(setErrorCount_expeditedstatus_form(0));
    dispatch(setErrorCount_icmawrs_form(0));
    dispatch(setErrorCount_verificationslist_form(0));
    dispatch(setErrorCount_todo_form(0));
    dispatch(setErrorCount_runedbc_form(0));
    dispatch(setErrorCount_narrative_form(0));
    dispatch(update_answer_call_form([]));
    dispatch(update_cctanf_form([]));
    dispatch(update_childcareneedlist_form([]));
    dispatch(update_childcareonly_form([]));
    dispatch(update_citidentitylist_form([]));
    dispatch(update_csallprograms_form([]));
    dispatch(update_csauthrep_form([]));
    dispatch(update_cssummaryscreen_form([]));
    dispatch(update_dcexpenselist_form([]));
    dispatch(update_dvsass_form([]));
    dispatch(update_emplistinclist_form([]));
    dispatch(update_expeditedstatus_form([]));
    dispatch(update_expenselist_form([]));
    dispatch(update_famplanchildcare_form([]));
    dispatch(update_expenselist_form([]));
    dispatch(update_householdstatuslist_form([]));
    dispatch(update_icebt_form([]));
    dispatch(update_icmawrs_form([]));
    dispatch(update_indemoscreen_form([]));
    dispatch(update_livingarrangement_form([]));
    dispatch(update_mdcareexpenselist_form([]));
    dispatch(update_mdexpenselist_form([]));
    dispatch(update_medcondlist_form([]));
    dispatch(update_narrative_form([]));
    dispatch(update_noncompliancelist_form([]));
    dispatch(update_noncustparentlist_form([]));
    dispatch(update_otherprogramlist_form([]));
    dispatch(update_pcscheduledlist_form([]));
    dispatch(update_pregnancylist_form([]));
    dispatch(update_purchasepreparelist_form([]));
    dispatch(update_registration_form([]));
    dispatch(update_relationshiplist_form([]));
    dispatch(update_reportingpage_form([]));
    dispatch(update_resourcelist_form([]));
    dispatch(update_right_resp_form([]));
    dispatch(update_runedbc_form([]));
    dispatch(update_schoolattlist_form([]));
    dispatch(update_screenpw_form([]));
    dispatch(update_screenvr_form([]));
    dispatch(update_tanfdt_form([]));
    dispatch(update_tanfsuspensionbased_form([]));
    dispatch(update_tanfwpcoop_form([]));
    dispatch(update_timelimitsummary_form([]));
    dispatch(update_todo_form([]));
    dispatch(update_verificationslist_form([]));
    setAssessmentForm(false);
  };

  const showDrawer = () => {
    // setOpen(true);
    set_load_data(false);
    clearFields();
    set_contact_exists(false);
  };
  // const onClose = () => {
  //   // setOpen(false);
  //   // setMsg(false);
  // };
  let url_pdf = LAMBDAS.FORM_PDF + documentName;
  const { data, error } = useFormFetch(
    url_pdf,
    payLoad,
    "PUT",
    "application/pdf"
  );

  // let url_getData =
  //   LAMBDAS.GET_FORM_DETAILS +
  //   contactName +
  //   "&phoneNumber=" +
  //   contactPhoneNumber;
  // const { data1, error1 } = useDataFetch(
  //   url_getData,
  //   payLoad,
  //   "GET",
  //   "application/json"
  // );
  // let url_saveData = LAMBDAS.SAVE_CONTACT;
  // const { data2, error2 } = useSaveData(
  //   url_saveData,
  //   payLoad,
  //   "POST",
  //   "application/json"
  // );

  const populate_form = (datasourceList) => {
    console.log("[populate_form][1]", datasourceList);
    answer_call_form_ref.current.setFieldsValue(
      datasourceList[0]["TANF/CC/FOOD ASSISTANCE PROGRAM"]
    );
    right_resp_form_ref.current.setFieldsValue(
      datasourceList[1]["RIGHTS AND RESPONSIBILITIES"]
    );
    registration_form_ref.current.setFieldsValue(
      datasourceList[2]["REGISTRATION"]
    );

    let tanfdt_data =
      datasourceList[3]["TANF Drug Testing Program Requirements"];
    if (
      tanfdt_data.hasOwnProperty("Date of Conviction") &&
      tanfdt_data["Date of Conviction"] !== "" &&
      tanfdt_data["Date of Conviction"] !== null
    ) {
      tanfdt_data["Date of Conviction"] = moment(
        tanfdt_data["Date of Conviction"]
      );
    }

    tanfdt_form_ref.current.setFieldsValue(tanfdt_data);
    tanfwpcoop_form_ref.current.setFieldsValue(
      datasourceList[4]["TANF ONLY and WORK PROGRAM COOP"]
    );
    childcareonly_form_ref.current.setFieldsValue(
      datasourceList[5]["CHILD CARE ONLY"]
    );
    cctanf_form_ref.current.setFieldsValue(datasourceList[6]["CC/TANF ONLY"]);
    screennamevr_form_ref.current.setFieldsValue(
      datasourceList[7]["VOTER REGISTRATION"]
    );
    screennamepw_form_ref.current.setFieldsValue(
      datasourceList[8]["PROGRAM WITHDRAW"]
    );
    csallprograms_form_ref.current.setFieldsValue(
      datasourceList[9]["CASE SUMMARY (All Programs)"]
    );
    csauthrep_form_ref.current.setFieldsValue(
      datasourceList[10]["AUTHORIZED REP"]
    );
    cssummaryscreen_form_ref.current.setFieldsValue(
      datasourceList[11]["CONTACT SUMMARY SCREEN (All Programs)"]
    );
    reportingpage_form_ref.current.setFieldsValue(
      datasourceList[12]["REPORTING PAGE (Reviews/IR ONLY)"]
    );
    indemoscreen_form_ref.current.setFieldsValue(
      datasourceList[13]["INDIVIDUAL DEMOGRAPHICS SCREEN (All Programs)"]
    );
    citidentitylist_form_ref.current.setFieldsValue(
      datasourceList[14]["CITIZENSHIP/ IDENTITY LIST (All Programs)"]
    );
    householdstatuslist_form_ref.current.setFieldsValue(
      datasourceList[15]["HOUSEHOLD STATUS LIST"]
    );
    relationshiplist_form_ref.current.setFieldsValue(
      datasourceList[16]["RELATIONSHIP LIST (All Programs)"]
    );
    let pregnancylist_data =
      datasourceList[17]["PREGNANCY LIST (All Programs)"];
    if (
      pregnancylist_data.hasOwnProperty("Due Date") &&
      pregnancylist_data["Due Date"] !== "" &&
      pregnancylist_data["Due Date"] !== null
    ) {
      pregnancylist_data["Due Date"] = moment(pregnancylist_data["Due Date"]);
    }

    pregnancylist_form_ref.current.setFieldsValue(pregnancylist_data);
    otherprogramlist_form_ref.current.setFieldsValue(
      datasourceList[18]["OTHER PROGRAM LIST (All Programs)"]
    );
    noncompliancelist_form_ref.current.setFieldsValue(
      datasourceList[19]["NON-COMPLIANCE LIST (All Programs)"]
    );
    timelimitsummary_form_ref.current.setFieldsValue(
      datasourceList[20]["TIME LIMIT SUMMARY (All Programs)"]
    );
    purchasepreparelist_form_ref.current.setFieldsValue(
      datasourceList[21]["PURCHASE AND PREPARE LIST (FA)"]
    );
    schoolattlist_form_ref.current.setFieldsValue(
      datasourceList[22]["SCHOOL ATTENDANCE LIST (All Programs)"]
    );
    livingarrangement_form_ref.current.setFieldsValue(
      datasourceList[23]["LIVING ARRANGEMENTS"]
    );
    noncustparentlist_form_ref.current.setFieldsValue(
      datasourceList[24]["NONCUSTODIAL PARENT LIST (All Programs)"]
    );
    medcondlist_form_ref.current.setFieldsValue(
      datasourceList[25]["MEDICAL CONDITION LIST (FA, TANF)"]
    );
    emplistinclist_form_ref.current.setFieldsValue(
      datasourceList[26]["EMPLOYMENT LIST /INCOME LIST"]
    );
    resourcelist_form_ref.current.setFieldsValue(
      datasourceList[27]["RESOURCE LIST (All Programs)"]
    );
    expenselist_form_ref.current.setFieldsValue(
      datasourceList[28]["SHELTER - EXPENSE LIST (FA, TANF)"]
    );
    dcexpenselist_form_ref.current.setFieldsValue(
      datasourceList[29]["DEPENDENT CARE/ CSS - EXPENSE LIST (FA, TANF)"]
    );
    mdexpenselist_form_ref.current.setFieldsValue(
      datasourceList[30]["MEDICAL - EXPENSE LIST (FA, TANF)"]
    );
    mdcareexpenselist_form_ref.current.setFieldsValue(
      datasourceList[31]["MEDICARE EXPENSE LIST (FA Only)"]
    );
    childcareneedlist_form_ref.current.setFieldsValue(
      datasourceList[32][
        "CHILD CARE NEED LIST – PARENT AND/ OR CHILD CARE NEED LIST – CHILD (CC Only)"
      ]
    );
    pcscheduledlist_form_ref.current.setFieldsValue(
      datasourceList[33][
        "PARENT SCHEDULE LIST AND/ OR CHILD SCHEDULE LIST (CC Only)"
      ]
    );
    famplanchildcare_form_ref.current.setFieldsValue(
      datasourceList[34]["FAMILY PLAN – CHILD CARE LIST (CC Only)"]
    );
    tanfsuspensionbased_form_ref.current.setFieldsValue(
      datasourceList[35][
        "TANF Suspicion Based Drug Testing (Only those who meet suspicion-based indicators)"
      ]
    );
    dvsass_form_ref.current.setFieldsValue(
      datasourceList[36][
        "DOMESTIC VIOLENCE, SEXUAL ASSAULT, OR STALKING SCREENING (REQUIRED)"
      ]
    );
    icebt_form_ref.current.setFieldsValue(datasourceList[37]["EBT"]);
    expeditedstatus_form_ref.current.setFieldsValue(
      datasourceList[38]["EXPEDITED STATUS"]
    );
    icmawrs_form_ref.current.setFieldsValue(
      datasourceList[39]["MANDATORY ABAWD / E&T / WORK REGISTRANT SCRIPTS"]
    );
    let verificationslist_data = datasourceList[40]["VERIFICATIONS LIST"];
    if (
      verificationslist_data.hasOwnProperty("Due Date") &&
      verificationslist_data["Due Date"] !== "" &&
      verificationslist_data["Due Date"] !== null
    ) {
      verificationslist_data["Due Date"] = moment(
        verificationslist_data["Due Date"]
      );
    }

    verificationslist_form_ref.current.setFieldsValue(verificationslist_data);
    todo_form_ref.current.setFieldsValue(datasourceList[41]["TODO"]);
    runedbc_form_ref.current.setFieldsValue(datasourceList[42]["RUN EDBC"]);
    narrative_form_ref.current.setFieldsValue(datasourceList[43]["NARRATIVE"]);

    answer_call_form_ref.current.setFieldsValue({
      "Agent Name": agentName,
    });
    right_resp_form_ref.current.setFieldsValue({
      "Worker Name": agentName,
    });

    narrative_form_ref.current.setFieldsValue({
      "Worker Name:": agentName,
    });

    set_collapse_active_keys([
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
    ]);
    set_contact_loading(false);
    set_load_data(true);
  };

  useEffect(() => {
    setContactID(props.contactID);
    setAgentName(props.agentName);
    setAgentId(props.agentID);
    set_collapse_active_keys([
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
    ]);

    // answer_call_form_ref.current.setFieldsValue({
    //   "Agent Name": props.agentName,
    // });
    // right_resp_form_ref.current.setFieldsValue({
    //   "Worker Name": props.agentName,
    // });

    // narrative_form_ref.current.setFieldsValue({
    //   "Worker Name:": props.agentName,
    // });
    const c_date = new Date();
    setCallAnswered(moment(c_date, "MMMM Do YYYY, h:mm:ss a").format("LLL"));
  }, [props.contactID]);

  const addZero = (i) => {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  };

  const sendData = () => {
    switch ((data === null, error === null)) {
      case (false, true):
        console.log("[sendData][false-true]");
        // sessionStorage.clear();
        set_load_data(false);
        clearFields();
        set_contact_exists(false);

        break;
      case (true, false):
        console.log("INSIDE TRUE FALSE");

        break;
      default:
        break;
    }
  };

  // const onFinish_retrievecontact = (values) => {};

  // const getContactDetails = () => {
  //   retrievecontact_form.submit();
  //   let ciD = "";
  //   getContact(ciD);
  // };
  const isSendEmail = (e) => {
    console.log(`checked = ${e.target.checked}`);
    setSendEmail(e.target.checked);
  };

  const generate_pdf = (display_data) => {
    let clientName = "";
    const PDF_WIDTH = 816;
    const PDF_HEIGHT = PDF_WIDTH * 1.2941;
    const doc = new jsPDF("p", "pt"[(PDF_WIDTH, PDF_HEIGHT)]);
    const margin = { top: 20, left: 15, right: 15, bottom: 10 };

    doc.addImage(dcf_logo, "PNG", 170, 5, 30, 20);
    let yPosition = margin.top + 15;
    const bottomMargin = margin.bottom;
    const pageHeight = doc.internal.pageSize.height;
    const pageWidth = doc.internal.pageSize.width;
    const textWidth = pageWidth - margin.left - margin.right;

    display_data.forEach((element) => {
      let [dataKey, dataValue] = Object.entries(element)[0];
      doc.setFontSize(10);
      doc.text(`${dataKey}`, margin.left, yPosition);
      yPosition += 5;

      Object.entries(dataValue).forEach(([key, value]) => {
        if (key === "Client Name") {
          clientName = value;
        }
        if (dataKey === "Last Update Details") {
          let newValue = "";
          for (let key in value) {
            newValue += key + ": " + value[key] + "\t";
          }
          value = newValue.trim();
        }

        if (yPosition + 10 > pageHeight - bottomMargin) {
          doc.addPage();
          yPosition = margin.top;
        }
        const wrappedText = doc.splitTextToSize(`${key}:${value}`, textWidth);
        wrappedText.forEach((line) => {
          doc.setFontSize(8);
          doc.text(line, margin.left + 5, yPosition);
          yPosition += 5;
        });
        // doc.text(`${key}:${value}`, 20, yPosition);
        // yPosition += 5;
      });
      // yPosition += 2;

      if (yPosition + 10 > pageHeight - bottomMargin) {
        doc.addPage();
        yPosition = margin.top;
      }
    });
    const cDate = new Date();
    let dateNTimestampFormat =
      cDate.getFullYear() +
      "-" +
      String(cDate.getMonth() + 1).padStart(2, 0) +
      "-" +
      String(cDate.getDate()).padStart(2, 0) +
      "_" +
      Math.floor(cDate.getTime() / 1000);
    // let currentDate = cDate.toDateString().split(" ").splice(1, 3).join("_");
    // let currentTime = new Date();
    // let docName =
    //   contactID +
    //   "_" +
    //   currentDate +
    //   "_" +
    //   addZero(currentTime.getHours()) +
    //   addZero(currentTime.getMinutes()) +
    //   addZero(currentTime.getSeconds()) +
    //   ".pdf";
    // let docName =
    //   "KEES Case^SSP Medical Uploaded Document^" +
    //   `${props.caseNumber === "" ? contactID : props.caseNumber}` +
    //   "^" +
    //   clientName +
    //   "^" +
    //   dateNTimestampFormat;
    let docName =
      "KEES Case^Journaling^" +
      props.caseNumber +
      "^" +
      clientName +
      "^" +
      dateNTimestampFormat +
      ".pdf";
    setDocumentName(docName);
    let blob = doc.output("blob");
    let formData = new FormData();
    formData.append("file", blob, docName);
    doc.save(docName);
    return formData;
  };

  const submit_forms = () => {
    // let pdf_data = [];
    let prep_datasource = [];
    let client_name = "";
    let callback_number = "";
    for (const item of LIST_FORMS) {
      for (let key0 in interview_data) {
        for (let key1 in interview_data[key0]) {
          for (let temp_key in interview_data[key0][key1]) {
            if (temp_key === "Client Name") {
              client_name = interview_data[key0][key1][temp_key];
            }
            if (temp_key === "Callback Number") {
              callback_number = interview_data[key0][key1][temp_key];
            }

            if (interview_data[key0][key1][temp_key] === undefined)
              interview_data[key0][key1][temp_key] = "";
          }
          if (item === key1) {
            prep_datasource.push(interview_data[key0]);
          }
        }
      }
    }
    const cDate = new Date();
    let dateNTimestampFormat =
      cDate.getFullYear() +
      "-" +
      String(cDate.getMonth() + 1).padStart(2, 0) +
      "-" +
      String(cDate.getDate()).padStart(2, 0) +
      "_" +
      Math.floor(cDate.getTime() / 1000);
    let contactFile =
      "KEES Case^Journaling^" +
      props.caseNumber +
      "^" +
      client_name +
      "^" +
      dateNTimestampFormat;
    // "_" +
    // props.agentName.replace(/ /g, "");
    //KEES Case^SSP Medical Uploaded Document^[CASE #]^[Case Name]^[DATE(Format: YEAR-Month-DAY)]^[Timestamp].p

    if (completed !== "COMPLETED") {
      console.log("[TEMP DATA]");
      let isAutosave = false;

      sendContactDetails(
        contactFile,
        client_name,
        callback_number,
        prep_datasource,
        isAutosave
      );

      // setAssessmentForm(true);

      if (sendEmail) {
        console.log("inside if sendEmail");
        sendEmailByAgent(contactID, prep_datasource, contactFile);
      }
    } else {
      let total_err = parseInt(
        answer_call_form_error_count.errorCount +
          right_resp_form_error_count.errorCount +
          registration_form_error_count.errorCount +
          tanfdt_form_error_count.errorCount +
          tanfwpcoop_form_error_count.errorCount +
          childcareonly_form_error_count.errorCount +
          cctanf_form_error_count.errorCount +
          screenvr_form_error_count.errorCount +
          screenpw_form_error_count.errorCount +
          csallprograms_form_error_count.errorCount +
          csauthrep_form_error_count.errorCount +
          cssummaryscreen_form_error_count.errorCount +
          reportingpage_form_error_count.errorCount +
          indemoscreen_form_error_count.errorCount +
          citidentitylist_form_error_count.errorCount +
          householdstatuslist_form_error_count.errorCount +
          relationshiplist_form_error_count.errorCount +
          pregnancylist_form_error_count.errorCount +
          otherprogramlist_form_error_count.errorCount +
          noncompliancelist_form_error_count.errorCount +
          timelimitsummary_form_error_count.errorCount +
          purchasepreparelist_form_error_count.errorCount +
          schoolattlist_form_error_count.errorCount +
          livingarrangement_form_error_count.errorCount +
          noncustparentlist_form_error_count.errorCount +
          medcondlist_form_error_count.errorCount +
          emplistinclist_form_error_count.errorCount +
          resourcelist_form_error_count.errorCount +
          expenselist_form_error_count.errorCount +
          dcexpenselist_form_error_count.errorCount +
          mdexpenselist_form_error_count.errorCount +
          mdcareexpenselist_form_error_count.errorCount +
          childcareneedlist_form_error_count.errorCount +
          pcscheduledlist_form_error_count.errorCount +
          famplanchildcare_form_error_count.errorCount +
          tanfsuspensionbased_form_error_count.errorCount +
          dvsass_form_error_count.errorCount +
          icebt_form_error_count.errorCount +
          expeditedstatus_form_error_count.errorCount +
          icmawrs_form_error_count.errorCount +
          verificationslist_form_error_count.errorCount +
          todo_form_error_count.errorCount +
          runedbc_form_error_count.errorCount +
          narrative_form_error_count.errorCount
      );
      if (total_err === 0) {
        // console.log("For Update", sendEmail);
        let pdf_form = generate_pdf(prep_datasource);

        sendFormData(pdf_form);

        sendData();
      }
    }
  };

  const cancel = (e) => {
    console.log(e);
  };
  // const onSelect = (selectedKeys, info) => {
  //   console.log("selected", selectedKeys, info);
  // };
  const sendFormData = (form_data) => {
    //replace with any final validation checks if needed
    if (true) {
      setpayLoad(form_data);
    }
  };

  const radioChange = (e) => {
    console.log(`radio to ${e.target.value}`);
    setCompleted(e.target.value);
  };

  const onChange = (key) => {
    console.log(`Collapsible: ${key}`);
    if (Object.keys(key).length !== 0) {
      set_collapse_active_keys([
        `${key[Object.keys(key)[Object.keys(key).length - 1]]}`,
      ]);
    } else {
      set_collapse_active_keys([]);
    }
  };

  const onValuesChange_temp_data_form = (formData) => {
    console.log(
      "GET FIELDS VALUE",
      temp_data_form_ref.current.getFieldsValue()
    );
  };

  // const onOk_temp_data_form = (data) => {
  //   set_collapse_active_keys([
  //     "1",
  //     "2",
  //     "3",
  //     "4",
  //     "5",
  //     "6",
  //     "7",
  //     "8",
  //     "9",
  //     "10",
  //     "11",
  //     "12",
  //     "13",
  //     "14",
  //   ]);
  //   console.log(
  //     "[onOk_temp_data_form]",
  //     temp_data_form_ref.current.getFieldsValue()
  //   );
  //   let isExist = temp_data_form_ref.current.getFieldsValue();
  //   let cIdd = isExist["retrieve_contact_id"]; //replaced to case number

  //   console.log("[onOk_temp_data_form][cIdd", cIdd);
  //   console.log(
  //     "[onOk_temp_data_form][isExistingContact]",
  //     isExist["isExistingContact"]
  //   );
  //   set_contact_loading(true);
  //   if (
  //     (cIdd !== "" && isExist["isExistingContact"] === true) ||
  //     (cIdd !== undefined && isExist["isExistingContact"] === true) ||
  //     (cIdd !== "" && isExist["isExistingContact"] === undefined)
  //   ) {
  //     console.log("[onOk_temp_data_form]-inside if");
  //     set_contact_exists(true);

  //     setTimeout(() => {
  //       getContact(cIdd);
  //     }, 5000); //5 seconds
  //   } else {
  //     console.log("[onOk_temp_data_form]-inside else");
  //     set_contact_loading(false);
  //     set_contact_exists(true);
  //     set_load_data(true);
  //   }
  // };
  // const onReset_temp_data_form = (data) => {
  //   console.log(
  //     "GET FIELDS VALUE7",
  //     temp_data_form_ref.current.getFieldsValue()
  //   );
  //   temp_data_form_ref.current.resetFields();
  // };

  // // const handleSwitch = (val, e) => {
  // //   console.log("[SWITCH][v]", val);
  // //   console.log("[SWITCH][e]", e);

  // //   if (!val) {
  // //     set_contact_loading(false);
  // //     set_contact_exists(true);
  // //     set_load_data(true);
  // //   }
  // // };

  return (
    <div
      style={{
        height: props.form_height,
        // height: "100%",
        overflow: "auto",
        backgroundColor: "#ffffff",
        // backgroundColor: "#E5E4E2",
        borderRadius: 5,
        // padding: "5px",
      }}
    >
      <Row>
        {assessmentForm ? (
          <Alert
            style={{
              position: "fixed",
              top: 0,
              // left: 0,
              right: 0,
              zIndex: 9999,
              padding: "10px",
            }}
            type="warning"
            banner
            // closable
            message={
              "Total missing fields " +
              (answer_call_form_error_count.errorCount +
                right_resp_form_error_count.errorCount +
                registration_form_error_count.errorCount +
                tanfdt_form_error_count.errorCount +
                tanfwpcoop_form_error_count.errorCount +
                childcareonly_form_error_count.errorCount +
                cctanf_form_error_count.errorCount +
                screenvr_form_error_count.errorCount +
                screenpw_form_error_count.errorCount +
                csallprograms_form_error_count.errorCount +
                csauthrep_form_error_count.errorCount +
                cssummaryscreen_form_error_count.errorCount +
                reportingpage_form_error_count.errorCount +
                indemoscreen_form_error_count.errorCount +
                citidentitylist_form_error_count.errorCount +
                householdstatuslist_form_error_count.errorCount +
                relationshiplist_form_error_count.errorCount +
                pregnancylist_form_error_count.errorCount +
                otherprogramlist_form_error_count.errorCount +
                noncompliancelist_form_error_count.errorCount +
                timelimitsummary_form_error_count.errorCount +
                purchasepreparelist_form_error_count.errorCount +
                schoolattlist_form_error_count.errorCount +
                livingarrangement_form_error_count.errorCount +
                noncustparentlist_form_error_count.errorCount +
                medcondlist_form_error_count.errorCount +
                emplistinclist_form_error_count.errorCount +
                resourcelist_form_error_count.errorCount +
                expenselist_form_error_count.errorCount +
                dcexpenselist_form_error_count.errorCount +
                mdexpenselist_form_error_count.errorCount +
                mdcareexpenselist_form_error_count.errorCount +
                childcareneedlist_form_error_count.errorCount +
                pcscheduledlist_form_error_count.errorCount +
                famplanchildcare_form_error_count.errorCount +
                tanfsuspensionbased_form_error_count.errorCount +
                dvsass_form_error_count.errorCount +
                icebt_form_error_count.errorCount +
                expeditedstatus_form_error_count.errorCount +
                icmawrs_form_error_count.errorCount +
                verificationslist_form_error_count.errorCount +
                todo_form_error_count.errorCount +
                runedbc_form_error_count.errorCount +
                narrative_form_error_count.errorCount)
            }
          />
        ) : (
          ""
        )}
      </Row>
      {/* {!is_contact_exist ? (
        <RetrieveTempData
          ref={temp_data_form_ref}
          onValuesChange={onValuesChange_temp_data_form}
          onOkay={onOk_temp_data_form}
          onReset={onReset_temp_data_form}
          // handleSwitch={handleSwitch}
          // agentName={props.agentName}
        />
      ) : ( */}
      <div>
        <Spin tip="Loading..." spinning={is_contact_loading}>
          <ConfigProvider
            theme={{
              token: {
                colorText: "#FFFFFF",
                fontSize: props.font_size,
                colorBorder: "#FFFFFF",
              },
              components: {
                Collapse: {
                  contentBg: "#818589",
                },
                Select: {
                  selectorBg: "#818589",
                  optionSelectedBg: "#818589",
                  colorBgElevated: "#818589",
                  activeBorderColor: "#FFFFFF",
                },
                Input: {
                  colorText: "#000000",
                  colorTextDisabled: "#000000",
                },
                DatePicker: {
                  colorText: "#000000",
                },
                Alert: {
                  colorText: "#000000",
                },
              },
            }}
          >
            <Collapse
              defaultActiveKey={["1"]}
              activeKey={collapse_active_keys}
              onChange={onChange}
            >
              <Panel
                style={{
                  backgroundColor: "#122249",
                  // contentBg: "#122249",
                }}
                header={
                  <div>
                    TANF/CC/FOOD ASSISTANCE PROGRAM{" "}
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={answer_call_form_error_count.errorCount}
                    />
                  </div>
                }
                key="1"
                // extra={
                //   <div style={{ textAlign: "right" }}>
                //     <Tooltip title="Close">
                //       <CloseCircleTwoTone
                //         style={{ fontSize: "25px" }}
                //         onClick={showDrawer}
                //       />
                //     </Tooltip>

                //     {/* <Button onClick={showDrawer}>

                //         <EllipsisOutlined style={{ color: "GrayText" }} />
                //       </Button> */}
                //   </div>
                // }
              >
                <AnswerCall
                  callAnswered={callAnswered}
                  agentName={props.agentName}
                  // agentName={agentName}
                  callbackNumber={props.customerNumber}
                  caseName={props.caseName}
                  // onFinish={onFinish_answerCall}
                  // form={answer_call_form}
                  ref={answer_call_form_ref}
                  onValuesChange={onValuesChange_answer_call_form}
                />
              </Panel>

              <Panel
                header={
                  <div>
                    RIGHTS AND RESPONSIBILITIES
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={right_resp_form_error_count.errorCount}
                    />
                  </div>
                }
                key="2"
                style={{ backgroundColor: "#e8ac3c" }}
              >
                <RightsAndResponsibilities
                  agentName={props.agentName}
                  // onFinish={onFinish_rightAndResp}
                  // form={right_resp_form}
                  ref={right_resp_form_ref}
                  onValuesChange={onValuesChange_right_resp_form}
                />
              </Panel>
              <Panel
                header={
                  <div>
                    REGISTRATION
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={registration_form_error_count.errorCount}
                    />
                  </div>
                }
                key="3"
                style={{ backgroundColor: "#787373" }}
              >
                <Registration
                  queue={props.queue}
                  caseNumber={props.caseNumber}
                  caseName={props.caseName}
                  ref={registration_form_ref}
                  onValuesChange={onValuesChange_registration_form}
                />
              </Panel>
              <Panel
                header={
                  <div>
                    SCREENING
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={
                        tanfdt_form_error_count.errorCount +
                        tanfwpcoop_form_error_count.errorCount +
                        childcareonly_form_error_count.errorCount +
                        cctanf_form_error_count.errorCount
                      }
                    />
                  </div>
                }
                key="4"
                style={{ backgroundColor: "#122249" }}
              >
                <Row style={{ fontWeight: "bold" }}>
                  TANF Drug Testing Program Requirements
                </Row>
                <Row>
                  <TANFDT
                    felonyAnswer={props.felonyAnswer}
                    ref={tanfdt_form_ref}
                    onValuesChange={onValuesChange_tanfdt_form}
                    // onFinish={onFinish_tanfdt}
                    // form={tanfdt_form}
                  />
                </Row>

                <Row style={{ fontWeight: "bold" }}>
                  TANF ONLY and WORK PROGRAM COOP
                </Row>
                <Row>
                  <TANFWPCOOP
                    ref={tanfwpcoop_form_ref}
                    onValuesChange={onValuesChange_tanfwpcoop_form}
                    // onFinish={onFinish_tanfwpcoop}
                    // form={tanfwpcoop_form}
                  />
                </Row>
                <Row style={{ fontWeight: "bold" }}>CHILD CARE ONLY</Row>
                <Row>
                  <CHILDCAREONLY
                    ref={childcareonly_form_ref}
                    onValuesChange={onValuesChange_childcareonly_form}
                    // onFinish={onFinish_childcareonly}
                    // form={childcareonly_form}
                  />
                </Row>
                <Row style={{ fontWeight: "bold" }}>CC/TANF ONLY</Row>
                <Row>
                  <CC_TANF
                    ref={cctanf_form_ref}
                    onValuesChange={onValuesChange_cctanf_form}
                    // onFinish={onFinish_cctanf}
                    // form={cctanf_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    SYSTEM ENTRY
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={
                        screenvr_form_error_count.errorCount +
                        screenpw_form_error_count.errorCount
                      }
                    />
                  </div>
                }
                key="5"
                style={{ backgroundColor: "#e8ac3c" }}
              >
                <Row style={{ marginTop: "10px" }}>
                  <ScreenNameVR
                    ref={screennamevr_form_ref}
                    onValuesChange={onValuesChange_screennamevr_form}
                    // onFinish={onFinish_screennamevr}
                    // form={screennamevr_form}
                  />
                </Row>
                <Row style={{ fontWeight: "bold" }}>
                  Screen Name: PROGRAM WITHDRAW
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <ScreenNamePW
                    ref={screennamepw_form_ref}
                    onValuesChange={onValuesChange_screennamepw_form}
                    // onFinish={onFinish_screennamepw}
                    // form={screennamepw_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    CASE SUMMARY
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={
                        csallprograms_form_error_count.errorCount +
                        csauthrep_form_error_count.errorCount
                      }
                    />
                  </div>
                }
                key="6"
                style={{ backgroundColor: "#8b8f86" }}
              >
                <Row style={{ marginTop: "10px" }}>
                  <CS_ALL_PROGRAMS
                    ref={csallprograms_form_ref}
                    onValuesChange={onValuesChange_csallprograms_form}
                    // onFinish={onFinish_csallprograms}
                    // form={csallprograms_form}
                  />
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <CS_AUTHREP
                    ref={csauthrep_form_ref}
                    onValuesChange={onValuesChange_csauthrep_form}
                    // onFinish={onFinish_csauthrep}
                    // form={csauthrep_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    CUSTOMER INFORMATION (Local Tab) Non- Financial
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={
                        cssummaryscreen_form_error_count.errorCount +
                        reportingpage_form_error_count.errorCount +
                        indemoscreen_form_error_count.errorCount +
                        citidentitylist_form_error_count.errorCount +
                        householdstatuslist_form_error_count.errorCount +
                        relationshiplist_form_error_count.errorCount +
                        pregnancylist_form_error_count.errorCount +
                        otherprogramlist_form_error_count.errorCount +
                        noncompliancelist_form_error_count.errorCount +
                        timelimitsummary_form_error_count.errorCount +
                        purchasepreparelist_form_error_count.errorCount +
                        schoolattlist_form_error_count.errorCount +
                        livingarrangement_form_error_count.errorCount +
                        noncustparentlist_form_error_count.errorCount +
                        medcondlist_form_error_count.errorCount
                      }
                    />
                  </div>
                }
                key="7"
                style={{ backgroundColor: "#122249" }}
              >
                <Row style={{ marginTop: "10px" }}>
                  <CS_SUMMARY_SCREEN
                    ref={cssummaryscreen_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_cssummaryscreen}
                    // form={cssummaryscreen_form}
                  />
                </Row>
                <Row style={{ fontWeight: "bold" }}>
                  Screen Name: REPORTING PAGE (Reviews/IR ONLY)
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <ReportingPage
                    ref={reportingpage_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_reportingpage}
                    // form={reportingpage_form}
                  />
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <INDEMOSCREEN
                    ref={indemoscreen_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_indemoscreen}
                    // form={indemoscreen_form}
                  />
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <CITIDENTITYLIST
                    ref={citidentitylist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_citidentitylist}
                    // form={citidentitylist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <HOUSEHOLDSTATUSLIST
                    ref={householdstatuslist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_householdstatuslist}
                    // form={householdstatuslist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <RELATIONSHIPLIST
                    ref={relationshiplist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_relationshiplist}
                    // form={relationshiplist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <PREGNANCYLIST
                    ref={pregnancylist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_pregnancylist}
                    // form={pregnancylist_form}
                  />
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <OTHERPROGRAMLIST
                    ref={otherprogramlist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_otherprogramlist}
                    // form={otherprogramlist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <NONCOMPLIANCELIST
                    ref={noncompliancelist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_noncompliancelist}
                    // form={noncompliancelist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <TIMELIMITSUMMARY
                    ref={timelimitsummary_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_timelimitsummary}
                    // form={timelimitsummary_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <PURCHASEPREPARELIST
                    ref={purchasepreparelist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_purchasepreparelist}
                    // form={purchasepreparelist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <SCHOOLATTLIST
                    ref={schoolattlist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_schoolattlist}
                    // form={schoolattlist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <LIVINGARRANGEMENT
                    ref={livingarrangement_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_livingarrangement}
                    // form={livingarrangement_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <NONCUSTPARENTLIST
                    ref={noncustparentlist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_noncustparentlist}
                    // form={noncustparentlist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <MEDCONDLIST
                    ref={medcondlist_form_ref}
                    onValuesChange={onValuesChange_cssummaryscreen_form}
                    // onFinish={onFinish_medcondlist}
                    // form={medcondlist_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    CUSTOMER INFORMATION LOCAL TAB - FINANCIAL
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={
                        emplistinclist_form_error_count.errorCount +
                        resourcelist_form_error_count.errorCount
                      }
                    />
                  </div>
                }
                key="8"
                style={{ backgroundColor: "#e8ac3c" }}
              >
                <Row style={{ marginTop: "10px" }}>
                  <EMPLISTINCLIST
                    ref={emplistinclist_form_ref}
                    onValuesChange={onValuesChange_emplistinclist_form}
                    // onFinish={onFinish_emplistinclist}
                    // form={emplistinclist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <RESOURCELIST
                    ref={resourcelist_form_ref}
                    onValuesChange={onValuesChange_emplistinclist_form}
                    // onFinish={onFinish_resourcelist}
                    // form={resourcelist_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    SHELTER
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={expenselist_form_error_count.errorCount}
                    />
                  </div>
                }
                key="9"
                style={{ backgroundColor: "#8b8f86" }}
              >
                <Row style={{ marginTop: "10px" }}>
                  <EXPENSELIST
                    ref={expenselist_form_ref}
                    onValuesChange={onValuesChange_expenselist_form}
                    // onFinish={onFinish_expenselist}
                    // form={expenselist_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    DEPENDENT CARE/ CSS
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={dcexpenselist_form_error_count.errorCount}
                    />
                  </div>
                }
                key="10"
                style={{ backgroundColor: "#122249" }}
              >
                <Row>
                  <Col span={4}>Screen Name: </Col>
                  <Col style={{ fontWeight: "bold" }}>
                    EXPENSE LIST (FA, TANF)
                  </Col>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <DCEXPENSELIST
                    ref={dcexpenselist_form_ref}
                    onValuesChange={onValuesChange_dcexpenselist_form}
                    // onFinish={onFinish_dcexpenselist}
                    // form={dcexpenselist_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    MEDICAL
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={
                        mdexpenselist_form_error_count.errorCount +
                        mdcareexpenselist_form_error_count.errorCount
                      }
                    />
                  </div>
                }
                key="11"
                style={{ backgroundColor: "#e8ac3c" }}
              >
                <Row>
                  <Col span={4}>Screen Name: </Col>
                  <Col style={{ fontWeight: "bold" }}>
                    EXPENSE LIST (FA, TANF)
                  </Col>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <MDEXPENSELIST
                    ref={mdexpenselist_form_ref}
                    onValuesChange={onValuesChange_mdexpenselist_form}
                    // onFinish={onFinish_mdexpenselist}
                    // form={mdexpenselist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <MDCAREEXPENSELIST
                    ref={mdcareexpenselist_form_ref}
                    onValuesChange={onValuesChange_mdexpenselist_form}
                    // onFinish={onFinish_mdcareexpenselist}
                    // form={mdcareexpenselist_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    CUSTOMER INFORMATION – CHILD CARE
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={
                        childcareneedlist_form_error_count.errorCount +
                        pcscheduledlist_form_error_count.errorCount +
                        famplanchildcare_form_error_count.errorCount +
                        tanfsuspensionbased_form_error_count.errorCount +
                        dvsass_form_error_count.errorCount
                      }
                    />
                  </div>
                }
                key="12"
                style={{ backgroundColor: "#8b8f86" }}
              >
                <Row style={{ marginTop: "10px" }}>
                  <CHILDCARENEEDLIST
                    ref={childcareneedlist_form_ref}
                    onValuesChange={onValuesChange_childcareneedlist_form}
                    // onFinish={onFinish_childcareneedlist}
                    // form={childcareneedlist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <PCSCHEDULEDLIST
                    ref={pcscheduledlist_form_ref}
                    onValuesChange={onValuesChange_childcareneedlist_form}
                    // onFinish={onFinish_pcscheduledlist}
                    // form={pcscheduledlist_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <FAMPLANCHILDCARE
                    ref={famplanchildcare_form_ref}
                    onValuesChange={onValuesChange_childcareneedlist_form}
                    // onFinish={onFinish_famplanchildcare}
                    // form={famplanchildcare_form}
                  />
                </Row>
                <Row>
                  <Col span={4}>Screen Name: </Col>
                  <Col style={{ fontWeight: "bold" }}>
                    TANF Suspicion Based Drug Testing (Only those who meet
                    suspicion-based indicators)
                  </Col>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <TANFSUSPENSIONBASED
                    ref={tanfsuspensionbased_form_ref}
                    onValuesChange={onValuesChange_childcareneedlist_form}
                    // onFinish={onFinish_tanfsuspensionbased}
                    // form={tanfsuspensionbased_form}
                  />
                </Row>

                <Row style={{ marginTop: "10px" }}>
                  <DVSASS
                    ref={dvsass_form_ref}
                    onValuesChange={onValuesChange_childcareneedlist_form}
                    // onFinish={onFinish_dvsass}
                    // form={dvsass_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    INFORMING CLIENTS
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={
                        icebt_form_error_count.errorCount +
                        expeditedstatus_form_error_count.errorCount +
                        icmawrs_form_error_count.errorCount +
                        verificationslist_form_error_count.errorCount +
                        todo_form_error_count.errorCount +
                        runedbc_form_error_count.errorCount
                      }
                    />
                  </div>
                }
                key="13"
                style={{ backgroundColor: "#122249" }}
              >
                <Row>
                  <Col style={{ fontWeight: "bold" }}>Screen Name: EBT</Col>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <ICEBT
                    ref={icebt_form_ref}
                    onValuesChange={onValuesChange_icebt_form}
                    // onFinish={onFinish_icebt}
                    // form={icebt_form}
                  />
                </Row>
                <Row>
                  <Col style={{ fontWeight: "bold" }}>
                    Screen Name: EXPEDITED STATUS
                  </Col>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <EXPEDITEDSTATUS
                    ref={expeditedstatus_form_ref}
                    onValuesChange={onValuesChange_icebt_form}
                    // onFinish={onFinish_expeditedstatus}
                    // form={expeditedstatus_form}
                  />
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <Col style={{ fontWeight: "bold" }}>
                    Screen Name: MANDATORY ABAWD / E&T / WORK REGISTRANT SCRIPTS
                  </Col>
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <ICMAWRS
                    ref={icmawrs_form_ref}
                    onValuesChange={onValuesChange_icebt_form}
                    // onFinish={onFinish_icmawrs}
                    // form={icmawrs_form}
                  />
                </Row>
                <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
                  VERIFICATIONS LIST
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <VERIFICATIONSLIST
                    ref={verificationslist_form_ref}
                    onValuesChange={onValuesChange_icebt_form}
                    // onFinish={onFinish_verificationslist}
                    // form={verificationslist_form}
                  />
                </Row>
                <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
                  TO DO
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <TODO
                    ref={todo_form_ref}
                    onValuesChange={onValuesChange_icebt_form}
                    // onFinish={onFinish_todo}
                    // form={todo_form}
                  />
                </Row>
                <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
                  RUN EDBC
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <RUNEDBC
                    ref={runedbc_form_ref}
                    onValuesChange={onValuesChange_icebt_form}
                    // onFinish={onFinish_runedbc}
                    // form={runedbc_form}
                  />
                </Row>
              </Panel>
              <Panel
                header={
                  <div>
                    NARRATIVE
                    <Badge
                      style={{ marginLeft: 50 }}
                      showZero={false}
                      count={narrative_form_error_count.errorCount}
                    />
                  </div>
                }
                key="14"
                style={{ backgroundColor: "#e8ac3c" }}
              >
                <Row style={{ marginTop: "10px" }}>
                  <NARRATIVE
                    ref={narrative_form_ref}
                    onValuesChange={onValuesChange_narrative_form}
                    agentName={props.agentName}
                    // onFinish={onFinish_narrative}
                    // form={narrative_form}
                  />
                </Row>
              </Panel>
            </Collapse>
          </ConfigProvider>

          <Row style={{ marginTop: 15 }}>
            <Col span={4}>
              <label>Form Status:</label>
            </Col>
            <Col span={12}>
              <Radio.Group
                // defaultValue="COMPLETED"
                // buttonStyle="solid"
                style={{ width: "100%" }}
                onChange={radioChange}
                value={completed}
              >
                <Radio value="COMPLETED">COMPLETED</Radio>
                <Radio value="INCOMPLETE">FOR UPDATE</Radio>
                {/* {completed !== "COMPLETED" ? (
                  <Checkbox onChange={isSendEmail}>Send Email</Checkbox>
                ) : (
                  ""
                )} */}
              </Radio.Group>
            </Col>
          </Row>
          {assessmentForm ? (
            <Alert
              message="Please complete the form/s."
              banner
              closable
              showIcon
              type="error"
              style={{ marginBottom: "15px" }}
            />
          ) : (
            ""
          )}
          {completed !== "" ? (
            <div>
              <Row gutter={2} style={{ margin: 15 }}>
                <Col span={12}>
                  <Popconfirm
                    title="Click Yes to submit."
                    description="Are you sure the details provided are final?"
                    onConfirm={submit_forms}
                    // onConfirm={submit_all_form}
                    onCancel={cancel}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button
                      type="primary"
                      style={{ width: "100%" }}
                      onClick={getAllFormData}
                    >
                      Submit
                    </Button>
                  </Popconfirm>
                </Col>
                <Col span={12}>
                  <Button type="primary" style={{ width: "100%" }}>
                    Cancel
                  </Button>
                </Col>
              </Row>
            </div>
          ) : (
            ""
          )}
        </Spin>
      </div>
      {/* )} */}
    </div>
  );
};
export default CustomerForm;
